import type { GrabbedContentSegment } from "./GrabbedContentSegment";

const HIGHLIGHT_REGEX = new RegExp(
  [
    // Path-like tokens ending in .tsx, with optional :line(:column) suffixes,
    // e.g. "src/components/Button.tsx:12:5".
    String.raw`(?<tsxPath>\/?[\w.$@~-]+(?:\/[\w.$@~-]+)*\.tsx(?!\w)(?::\d+(?::\d+)?)?)`,
    // Component names in react-grab stack entries, e.g. "in LoginForm".
    String.raw`(?<componentName>(?<=\bin )[A-Z][\w$]*)`,
  ].join("|"),
  "g"
);

// Splits grabbed clipboard content into plain-text, .tsx-path, and component
// name segments so the dialog can highlight the latter two. Segments
// concatenate back to the input.
export const splitGrabbedContent = (
  content: string
): GrabbedContentSegment[] => {
  const segments: GrabbedContentSegment[] = [];
  let lastIndex = 0;
  for (const match of content.matchAll(HIGHLIGHT_REGEX)) {
    if (match.index > lastIndex) {
      segments.push({
        text: content.slice(lastIndex, match.index),
        kind: "text",
      });
    }
    segments.push({
      text: match[0],
      kind: match.groups?.tsxPath !== undefined ? "tsxPath" : "componentName",
    });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < content.length) {
    segments.push({ text: content.slice(lastIndex), kind: "text" });
  }
  return segments;
};
